export function UUID() {
  return Date.now() + '' + Math.random();
}
